import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useAuthFetch } from "../api/authFetch";
import { IconButton } from '@mui/material';
import DisplaySettingsIcon from '@mui/icons-material/Edit';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LinearProgress from '@mui/material/LinearProgress';
import AgreementDialog from '../components/AgreementDialog';

export default function DataGridDemo() {



  const columns: GridColDef[] = [
    {
      field: "actions",
      headerName: "Actions",
      width:50,
      renderCell: (params) => {
        return (
          <IconButton onClick={() => handleOpen(params.row)}>
            <DisplaySettingsIcon />
          </IconButton>
        );
      }
    },
    { field: 'id', headerName: 'ID', width: 100},
    { field: 'agreementId', headerName: 'AgreementId', width: 100},
    {
      field: 'actual',
      headerName: 'Actual v.',
      width: 80,
      renderCell: (params) => (
        <>
        {params.row.actual ? (
          <CheckCircleIcon style={{ color: 'green' }} />
        ) : ''}
        </>
      ),
    },
    {
      field: 'last',
      headerName: 'Last v.',
      width: 80,
      renderCell: (params) => (
        <>
        {params.row.last ? (
          <CheckCircleIcon style={{ color: 'green' }} />
        ) : ''}
        </>
      ),
    },
    { field: 'name', headerName: 'Name', width: 400 },
    { field: 'actualVersion', headerName: 'Version', width: 80 },
    {
      field: 'purposes',
      headerName: 'Purposes',
      width: 300,
      renderCell: (params:any) => (
        <div>
        {/* Render your array data in a way that fits your UI */}
        {params.value?.map((value:any) => (
          <div key={value.code}>{value.name} </div>
        ))}
      </div>
      ),
    },
  ];





    const [open, setOpen] = useState(false);





    // OPEN DIALOG
    const handleOpen = (props:any) => {
      setItem(props);
      setOpen(true);
    };

    //CLOSE DIALOG
    const handleClose = () => {
      setOpen(false);
    };


    

    const authFetch = useAuthFetch();
    const [tableData, setTableData] = useState([]);


  
    const [search, setSearch] = useState('');
    const [onlyActual, setOnlyActual] = React.useState(true);

    const [item, setItem] = useState(Object);
    


    
    //PRESS ENTER IN SEARCH TEXT BOX
    const handleEnterInUrl = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault(); // prevent form submission
        loadData();
      }
    };


    const changeSearch = (event: { target: { value: React.SetStateAction<string>; }; }) => {
      setSearch(event.target.value)
    }



    // eslint-disable-next-line
    const loadData = async() => {



        const response = await authFetch(process.env.REACT_APP_AGREEMENTS_URL +"?search="+encodeURIComponent(search)+"&onlyActualOrLast="+encodeURIComponent(onlyActual)+"&noContent=true");
        
        if (response.status) {
            const agreements = await response.json();
            if (agreements != null)
            {
              setTableData(agreements);

            }
          }
    };
    
    useEffect(() => {
      loadData();
    // eslint-disable-next-line
    }, [])
   
  return (
    <Box sx={{ height: `auto`, width: '100%' }}>
      <Box
            component="form"
            sx={{
            '& .MuiTextField-root': { m: 1, width: '1000' },
            }}
            noValidate
            autoComplete="off"
          >
                <div  style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                <Button variant="contained" onClick={() => handleOpen({id:'new', actualVersion:"0.0", purposes:[], type:''})} sx={{pr:2}}>New agr.</Button>
                <TextField label="Search" id="txtSearch" value={search} onChange={changeSearch} onKeyDown={handleEnterInUrl} inputProps={{ style: { width: "600px" }}}
                   />
                <FormControlLabel control={<Checkbox checked={onlyActual} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setOnlyActual(event.target.checked)} />} label="Only actual or last versions" sx={{pl:8}} />
                <Button variant="contained" onClick={loadData}>Search</Button>
            </div> 
            <Box sx={{ width: '100%' }}>
                { tableData.length === 0 ? 
                  <LinearProgress key='waitingStatus'  />
                : null}
            </Box>
      </Box>
      <DataGrid
        rows={tableData}
        columns={columns}
        pageSize={13}
        rowsPerPageOptions={[13]}
        disableSelectionOnClick
        autoHeight={true}
        experimentalFeatures={{ newEditingApi: true }}
      />

      <AgreementDialog
        open={open}
        onClose={handleClose}
        id={item.id || 'new'}
        onSuccess={loadData}
      />
    </Box>
  );
}